import styles from '@styles/screens/StartDemoScreen.module.css'
import { ReactComponent as QontactTextSVG } from '@assets/SVGs/GeneralUse/Qontact.svg';
import { ReactComponent as QontactBackgroundSVG } from '@assets/SVGs/GeneralUse/QontactBackground.svg';
import { isMobile } from 'react-device-detect';
import { HorizontalContainer, VerticalContainer, VerticalSpacer } from "@components/General/Containers"
import { H2Title, Subtitle } from "@components/General/Titles"
import designSystem from "@styles/designSystem"
import { TextAreaInput, TextInput } from '@components/General/TextInput';
import { useState, useCallback, useMemo, useEffect } from 'react';
import { NormalButton } from '@components/General/Button';
import {} from "@localization/Localization"
import { useStartDemoViewModel } from '../view-models/StartDemoScreenViewModel';
import { QontactLogoPanel } from '@components/QontactLogoPanel';
import { OrangeQontactLogo } from '@components/OrangeQontactLogo';

interface MobileWrapperScreenProps {
    children: React.ReactNode;
}

export const MobileWrapperScreen: React.FC<MobileWrapperScreenProps> = ({ children }) => {
    return (
        <VerticalContainer gap={designSystem.paddingZero}>
            <VerticalContainer 
                alignment={'start'}
                maxWidth={'450px'}
                padding={designSystem.gapSm}
                paddingLeft={designSystem.paddingLg}
                paddingTop={designSystem.paddingSm}
            >
                <div style={{
                    width: '100%',
                    height: '24px',
                    alignContent: 'center'
                }}>
                    <OrangeQontactLogo/>
                </div>
            </VerticalContainer>
            <VerticalContainer 
                paddingTop={designSystem.paddingZero}
                paddingLeft={designSystem.paddingLg}
                paddingRight={designSystem.paddingLg}
                gap={designSystem.gapMd}
                maxWidth={'100%'} 
                height={'100%'}
                alignment={'top'}
            >
                {children}
           </VerticalContainer>
        </VerticalContainer>

)
}